/**
 * Created by yoavp on 8/25/2015.
 */
/**
 * Created by tomers on 6/18/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/agent-groups/agentGroupsMembersGridView.tmpl");
    var AgentGroupsMembersGridRowView = require("user-management-views/agent-groups/AgentGroupsMembersGridRowView");
    var AgentGroupsMembersGridEmptyView = require("user-management-views/agent-groups/AgentGroupsMembersGridEmptyView");

    var AgentGroupsMembersGridView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        AgentGroupsMembersGridView = Marionette.GridView.extend({
            className: "table-main ui-table",
            template: template,
            itemViewContainer: "tbody",
            itemView: AgentGroupsMembersGridRowView,
            emptyView: AgentGroupsMembersGridEmptyView,
            ui: {
                maxConversationsColumn: ".max-conversations"
            },

            initialize: function(options) {

            },

            onRender: function() {
                this.ui.maxConversationsColumn.toggleClass("hide", !LE.sessionManager.hasAsyncMessagingFeature());
            }
        });

    }

    LE.module("LEUserManagement", moduleDefinition);

    return AgentGroupsMembersGridView;
});
